import { useState } from 'react'
import { connect } from 'react-redux'
import { ModalBody } from 'reactstrap'
import apiService from 'utils/apiService'
import { updateExtensionSettings_action } from 'store/actions'
import { ModalForm, SettingsList } from 'modules/app/styles'
import { SwitchComponent } from './SwitchComponent'
import { handleApiError } from 'utils/helpers'
import { toast } from 'react-toastify'

export const NotificationSettings = (props) => {
  const { user } = props
  const userSettings = user.settings

  const [settings, set_settings] = useState({
    enableGmailToolbar: userSettings ? userSettings.settings.enableGmailToolbar : true,
    isCloseAfterCopied: userSettings ? userSettings.settings.isCloseAfterCopied : false,
    playSoundOnCopy: userSettings ? userSettings.settings.playSoundOnCopy : false,
  })

  const updateSettings = async (data) => {
    try {
      const response = await apiService('settings', data, 'post', true)
      toast.success('Settings saved!')
      props.updateExtensionSettings(response.settings)
    } catch (error) {
      handleApiError(error)
    }
  }
  return (
    <ModalBody>
      <ModalForm style={{ maxWidth: 400 }}>
        <div className='title'>Chrome Extension</div>
        <br />
        <SettingsList>
          <li className='section-title'>Extension Settings:</li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='enableGmailToolbar'>
              Enable in Gmail
            </label>
            <SwitchComponent label='enableGmailToolbar' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='isCloseAfterCopied'>
              Close after Response is copied
            </label>
            <SwitchComponent label='isCloseAfterCopied' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <hr />

          <li className='section-title'>General Settings:</li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='playSoundOnCopy'>
              Play sound after response copied
            </label>
            <SwitchComponent label='playSoundOnCopy' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          
        </SettingsList>
      </ModalForm>
    </ModalBody>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

const mapDispatchToProps = (dispatch) => ({
  updateExtensionSettings: (value) => dispatch(updateExtensionSettings_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettings)
